<template>
    <div>
        <CookingCheck :lower-button-name="lowerButtonName"
                      :upper-button-name="upperButtonName"
                      :re-input-flg="reInputFlg"
                      :menu-id="menuId"
                      :sub-menu-id="subMenuId"
                      :brandPath="brandPath"
                      :re-check-input-array="reCheckInputArray"/>
    </div>
</template>

<script>

    import CookingCheck from '@/app/components/CookingCheck.vue'

    export default {
        name: 'CookingCheckInput',
        components: {
            CookingCheck
        },
        // HACK: 親子コンポーネント要分割
        props:{
            brandPath: {
                type: String,
                require: true
            },
            menuId: {
                type: Number,
                require: true,
            },
            subMenuId: {
                type: Number,
                require: true
            },
            reInputFlg: {
                type: Number,
                default: 0,
            },
            reCheckInputArray: {
              type: Array,
              require: true,
              default: () => [],
            }
        },
        computed: {
            lowerButtonName: function () {
                const button = this.$store.getters['buttons/cookingCheckButton'](this.subMenuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            upperButtonName:  function () {
                const button = this.$store.getters['buttons/cookingCheckButton'](this.subMenuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
        },
    }
</script>
